export default from './DislikesPopUp';
